import AppliedCouponView from './applied-coupon-view'

export default AppliedCouponView
